export const updateEndClassSettings = (update) => ({
    type: "UPDATE_END_CLASS_SETTINGS",
    payload: { settings: update },
});
